import { type UseQueryLightError } from '@atlaskit/teams-client/src';
import {
	type TeamMembershipSettings,
	type TeamSearchMember,
	type TeamState,
	type TeamWithMemberships,
} from '@atlassian/ptc-common';

export interface TeamSearchState {
	teams: TeamWithMemberships[];
	isLoading: boolean;
	error?: UseQueryLightError;
	hasMore: boolean;
	loadMore: () => void;
}

export interface TeamSearchProps {
	first?: number;
	cursor?: string;
	query?: string;
	memberIds?: string[];
	batchSize?: number;
	skip?: boolean;
}

export interface Member {
	member?: TeamSearchMember;
}

export interface TeamSearchGQLTeamFormatV2 {
	team: {
		id: string;
		organizationId: string;
		membershipSettings: TeamMembershipSettings;
		description: string;
		displayName: string;
		state: TeamState;
		largeAvatarImageUrl: string;
		smallAvatarImageUrl: string;
		largeHeaderImageUrl: string;
		smallHeaderImageUrl: string;
		members: {
			nodes: Member[];
		};
		isVerified: boolean;
	};
	memberCount: number;
	includesYou: boolean;
}

export interface TeamSort {
	field: 'ID' | 'DISPLAY_NAME' | 'STATE';
	order?: 'ASC' | 'DESC';
}

export const sortBy: TeamSort[] = [
	{
		field: 'DISPLAY_NAME',
		order: 'ASC',
	},
];

export type TeamSearchV2Response = {
	team: {
		teamSearch: {
			nodes: TeamSearchGQLTeamFormatV2[];
			pageInfo: {
				hasNextPage: boolean;
				endCursor: string;
			};
		};
	};
};
